module.exports = __webpack_public_path__ + "static/media/OM.cc4d4bec.svg";